var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":""}},[_c('span',{staticClass:"indicator"},[_c('span',{staticClass:"indicator__value",style:({ width: _vm.integerValue + '%' })})]),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }